module.exports = require("zlib");


/*****************
 ** WEBPACK FOOTER
 ** external "zlib"
 ** module id = 49
 ** module chunks = 0
 **/